import { QueryKey } from '../../enums/QueryKey';
import { getScenarioShiftRows } from '../../services/budgetScenarioShiftRows';
import { createScenarioQuery } from './budgetScenarios';

export const useScenarioShiftRows = createScenarioQuery(QueryKey.BudgetScenarioShiftRows, getScenarioShiftRows);
